var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.7812 34.25H25.6875C18.4094 34.25 12.8438 39.8156 12.8438 47.0938V89.9062C12.8438 97.1844 18.4094 102.75 25.6875 102.75H72.7812C80.0594 102.75 85.625 97.1844 85.625 89.9062V47.0938C85.625 39.8156 80.0594 34.25 72.7812 34.25Z",
    fill: "#3D3D3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.016 34.6783C120.731 33.8221 119.019 33.8221 117.734 34.6783L96.3281 47.5221C95.0437 48.3783 94.1875 49.6627 94.1875 51.3752V85.6252C94.1875 87.3377 95.0437 88.6221 96.3281 89.4783L117.734 102.322C118.163 102.75 119.019 102.75 119.875 102.75C120.731 102.75 121.159 102.75 122.016 102.322C123.3 101.466 124.156 100.181 124.156 98.4689V38.5314C124.156 36.8189 123.3 35.5346 122.016 34.6783Z",
    fill: "#3D3D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.f07563b2819c8363bd6aaacc1b624df8.svg";
export { ForwardRef as ReactComponent };